export default __webpack_public_path__ + "static/media/KP.bb2294c8.svg";